import type { LocationOptions } from '@components/DriverTracking/Routes/api/schema'
import { compareStoreNumbers } from '@utils/grid'
import { TreeSelect } from 'antd'
import React, { useEffect } from 'react'

const { TreeNode } = TreeSelect

const buildSelectionTree = (data: LocationOptions[]) => {
  if (!data) return null
  const groupedByType = data
    .sort((a, b) => a.type.localeCompare(b.type))
    .reduce<Record<string, LocationOptions[]>>((acc, item) => {
      if (!acc[item.type]) {
        acc[item.type] = []
      }
      acc[item.type].push(item)
      return acc
    }, {})

  return Object.keys(groupedByType)
    .sort(compareStoreNumbers)
    .map((type) => (
      <TreeNode title={type === 'Store' ? 'Site' : type} value={type} key={type} selectable={false}>
        {groupedByType[type]
          .sort((a, b) => compareStoreNumbers(a.name, b.name))
          .map((item) => (
            <TreeNode title={item.name} value={item.id} key={item.id} />
          ))}
      </TreeNode>
    ))
}

export function LocationSelector({
  locationOptions,
  selectedLocationID,
  setSelectedLocation,
  updateSetting,
  updateSettingKey,
}: {
  locationOptions: LocationOptions[] | undefined
  selectedLocationID: string | null
  setSelectedLocation: (value: string) => void
  updateSetting: (key: string, value: string) => void
  updateSettingKey: string
}) {
  const options = buildSelectionTree(locationOptions)

  if (!locationOptions?.find((location) => location.id === selectedLocationID)) {
    selectedLocationID = null
  }

  const onChange = (value: string) => {
    setSelectedLocation(value)
    updateSetting(updateSettingKey, value)
  }

  return (
    <TreeSelect
      showSearch
      className='mr-3'
      value={selectedLocationID}
      onChange={onChange}
      placeholder='Select a Location'
      placement='bottomLeft'
      multiple={false}
      treeNodeFilterProp='title'
      style={{ maxWidth: '350px', minWidth: '350px' }}
    >
      {options}
    </TreeSelect>
  )
}
